import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy, TemplateRef, ViewEncapsulation, Self } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { FilterPipe } from '../../filter.pipe';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../datamodel/user';
import { ToggleService } from '../../services/toggle/toggle.service';
import { StateService } from '../../services/state/state.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent } from 'angular-calendar';
import * as _ from 'underscore';

import { timeout } from 'rxjs/operators/timeout';
import "rxjs/add/operator/take";
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as $ from 'jquery';
const colors: any = {
	red: {
		primary: '#ad2121',
		secondary: '#FAE3E3'
	},
	blue: {
		primary: '#1e90ff',
		secondary: '#D1E8FF'
	},
	yellow: {
		primary: '#e3bc08',
		secondary: '#FDF1BA'
	},
	green: {
		primary: '#07aa09',
		secondary: '#07aa09'
	}
};

interface Schedules {
	type: any;
}
interface Department {
	type: any;
}

interface providerSchedules {
	type: any;
}
interface scheduleShifts {
	type: any;
}
interface Provider {
	type: any;
}
interface Institution {
	type: any;
}

function mapSnapshot(changes: any) {
	return changes.map(a => {
		const data = a.payload.doc.data() as User;
		const id = a.payload.doc.id;
		return { id, ...data };
	});
}

function inArray(needle, haystack) {
	var length = haystack.length;
	for (var i = 0; i < length; i++) {
		if (haystack[i] == needle) return true;
	}
	return false;
}

@Component({
	selector: 'app-doctors',
	templateUrl: './doctors.component.html',
	styleUrls: ['./doctors.component.scss'],
	//changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [WindowService]
})

export class DoctorsComponent implements OnInit {
	@ViewChild('modalContent') modalContent: TemplateRef<any>;
	view: string = 'month';
	viewDate: Date = new Date();
	modalData: {
		action: string;
		event: CalendarEvent;
	};
	listEvents = [];
	refresh: Subject<any> = new Subject();

	public selectedInstitution: object;
	public user: User;
	public userProfile: object;
	private userRef: AngularFirestoreCollection<User>;
	obsUser: Observable<any>;

	private instituteRef: AngularFirestoreCollection<Institution>;
	obsInstitute: Observable<any>;

	private schedulesRef: AngularFirestoreCollection<any>;
	obsSchedules: Observable<any>;

	private providersRef: AngularFirestoreCollection<any>;
	obsProviders: Observable<any>;

	public doctorsList = [];
	activeDayIsOpen: boolean = false;

	private providerShiftsRef: AngularFirestoreCollection<any>;
	obsProviderShifts: Observable<any>;

	private shiftsRef: AngularFirestoreCollection<any>;
	obsShifts: Observable<any>;

	public scheduleList = [];
	public shiftsList = [];
	public hospId: string;
	provider: object;
	public errmsg = "";
	public searchText: string;

	events: CalendarEvent[];
	actions: CalendarEventAction[] = [
		{
			label: '<i class="fa fa-fw fa-pencil"></i>',
			onClick: ({ event }: { event: CalendarEvent }): void => {
				this.handleEvent('Edited', event);
			}
		},
		{
			label: '<i class="fa fa-fw fa-times"></i>',
			onClick: ({ event }: { event: CalendarEvent }): void => {
				this.events = this.events.filter(iEvent => iEvent !== event);
				this.handleEvent('Deleted', event);
			}
		}
	];

	constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, private fb: FormBuilder, public toggle: ToggleService, private state: StateService, private router: Router, private modal: NgbModal, private spinnerService: Ng4LoadingSpinnerService) {
		this.searchText = "";
	}

	getTotalDays(start_date, end_date) {
		let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
		let firstDate = new Date(start_date);
		let secondDate = new Date(end_date);
		return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
	}

	clearFilter(){
		this.provider = null;
		this.events = this.getDoctorSchedules();
		this.fetchEvents();
	}

	filterSchedules(provider){
		this.provider = provider;
		this.events = this.getDoctorSchedules(provider.id);
		this.fetchEvents();
	}

	getDoctorsList() {
		let objUser = firebase.auth().currentUser;
		const userRef = this.afs.collection('users').doc(objUser.uid);
		userRef.valueChanges().subscribe(user => {
			//Get user hospital
			const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
				? user['adminFor'][0].id : '';
			this.providersRef = this.afs.collection('providers', ref => ref.where('credentialedAt.' + userHospId + '.id', '==', userHospId).orderBy('last_name', 'asc'));
			this.providersRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(docs => {
				this.doctorsList = docs;
			});
		});
	}
	
	CalculateWeekendDays(fromDate, toDate, weekDayKey) {
		if (weekDayKey > 6) {
			weekDayKey = weekDayKey % 7;
		}
		var start = new Date(fromDate);
		var finish = new Date(toDate);
		var dayMilliseconds = 1000 * 60 * 60 * 24;
		var weekendDays = 0;
		while (start.getTime() <= finish.getTime()) {
			var day = start.getDay();
			if (day == weekDayKey) {
				weekendDays++;
			}
			start = new Date(+start + dayMilliseconds);
		}
		return weekendDays;
	}

	getDoctorSchedules(pid='') {
		let objUser = firebase.auth().currentUser;
		let result = [];
		let afs = this.afs;
		let self = this;
		let boxTitle = {};
		let boxDoctors = {};
		let totalDocs = {};
		let totalShiftDocs = {};
		//this.view = 'month';
		let obSchedules = [];
		let totalReqDoctors = {};
		let totalAvailDoctors = {};
        /**
         * Get users list
         */
		const userRef = this.afs.collection('users').doc(objUser.uid);
		userRef.valueChanges().subscribe(user => {
			//Get user hospital
			const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
				? user['adminFor'][0].id : '';

			//get schedules of hospitals
			self.schedulesRef = afs.collection('schedules', ref => ref.where('instituteRef.id', '==', userHospId).orderBy('name', 'asc'));
			self.schedulesRef.snapshotChanges().map(mapSnapshot).subscribe(schedules => {
				//console.log(schedules);
				let promiseArr = [];
				self.scheduleList = schedules;
				//self.scheduleFList = schedules;
				if (schedules && schedules.length > 0) {
					schedules.forEach(schedule => {
						obSchedules.push({ id: schedule.id, name: schedule.name });
						let promise = new Promise(function (resolve, reject) {
							self.shiftsRef = afs.collection('schedules_shifts', ref => ref.where('scheduleRef.id', '==', schedule.id).orderBy('day', 'asc'));
							self.shiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(scheduleShifts => {
								//console.log(scheduleShifts);
								if (scheduleShifts && scheduleShifts.length > 0) {
									let _scheduleShifts2 = [];
									scheduleShifts.forEach(function (scheduleShift) {
										scheduleShift['schedule'] = schedule;
										_scheduleShifts2.push(scheduleShift);
									});
									resolve(_scheduleShifts2)
								} else {
									reject('no shifts');
								}
							});
						});
						promiseArr.push(promise);
					});
				}
				if (promiseArr.length > 0) {
					Promise.all(promiseArr)
						.then(scheduleShifts => {
							//console.log(scheduleShifts);
							let _scheduleShifts = [];
							if (scheduleShifts && scheduleShifts.length > 0) {
								scheduleShifts.forEach(scheduleShift => {
									_scheduleShifts = _scheduleShifts.concat(scheduleShift);
								});
							}
							//console.log(_scheduleShifts);
							let promiseArr2 = [];
							if (_scheduleShifts && _scheduleShifts.length > 0) {
								var t = 0;
								let obDoctors = {};
								let boxProviderSdls = {};
								_scheduleShifts.forEach(_scheduleShift => {
									//totalReqDoctors = parseInt(_scheduleShift.total_docs);
									//totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
									if (totalShiftDocs[_scheduleShift.day] && typeof totalShiftDocs[_scheduleShift.day] !== "undefined" && totalShiftDocs[_scheduleShift.day] !== "undefined" && parseInt(totalShiftDocs[_scheduleShift.day]) > 0) {
										totalShiftDocs[_scheduleShift.day] = parseInt(totalShiftDocs[_scheduleShift.day]) + parseInt(_scheduleShift.total_docs);
										totalReqDoctors[_scheduleShift.day] = parseInt(totalReqDoctors[_scheduleShift.day]) + 1;//parseInt(_scheduleShift.total_docs);
									} else {
										totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
										totalReqDoctors[_scheduleShift.day] = 1;//parseInt(_scheduleShift.total_docs);
									}

									//boxTitle[_scheduleShift.schedule.id] = 'Schedule: ' + _scheduleShift.schedule.name + '<br>Department: ' + _scheduleShift.department + '<br>Shift Type: ' + _scheduleShift.shift_type + '<br>Doc Type: ' + _scheduleShift.doc_type;// + '<br>shift: ' + _scheduleShift.id;
									boxTitle[_scheduleShift.schedule.id] = _scheduleShift.schedule.name;

									let docImage = '../../assets/img/provider.png';

									let _promise = new Promise(function (resolve, reject) {
										if(pid !== '' && pid !== 'undefined'){
											self.providerShiftsRef = afs.collection('provider_schedules', ref => ref.where('shift.id', '==', _scheduleShift.id).where('provider.id', '==', pid).orderBy('shift_date', 'asc'));
										}else{
											self.providerShiftsRef = afs.collection('provider_schedules', ref => ref.where('shift.id', '==', _scheduleShift.id).orderBy('shift_date', 'asc'));
										}
										self.providerShiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(shifts => {
											let _promiseArr = [];
											if (shifts.length > 0) {
												shifts.forEach(function (shift, index) {
													// console.log(shift);
													//create doctors info tooltip
													//boxTitle[_scheduleShift.schedule.id] += '<br>' + shift.id;
													boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br>';

													let _promise = new Promise(function (_resolve, _reject) {
														if (shift.provider.ref !== '') {
															shift.provider.ref.get().then(doc => {
																//console.log(doc);
																if (doc.exists) {
																	let docId = doc.id;
																	let docData = doc.data();

																	let bgcolor = colors.green;
																	if (totalAvailDoctors[shift.shift_date_format] && typeof totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] > 0) {
																		totalAvailDoctors[shift.shift_date_format] = parseInt(totalAvailDoctors[shift.shift_date_format]) + 1;
																	} else {
																		totalAvailDoctors[shift.shift_date_format] = 1;
																	}

																	shift['provider'] = { 
																		id : doc.id, 
																		...docData
																	} 
																	shift['scheduleShift'] = _scheduleShift;
																	if (shift['provider'].photo == '') {
																		shift['provider'].photo = docImage;
																	}
																	//concat doctors info into box
																	boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] += '<ul class="doclist inline-item"><li><a class="whtText"><img src="' + shift['provider'].photo + '" /><span class="name">' + shift['provider'].first_name + ' ' + shift['provider'].last_name + '</span></a></li></ul>';
																	//boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] += '';
																	//push into doctor array

																	let key = shift.shift.id + '_' + shift.shift_timestamp;
																	//let key = shift.shift_date_format;
																	if (!obDoctors[key]) {
																		obDoctors[key] = [];
																	}
																	if (!boxProviderSdls[key]) {
																		boxProviderSdls[key] = [];
																	}
																	obDoctors[key].push({
																		id: shift['provider'].id,
																		name: shift['provider'].first_name + ' ' + shift['provider'].last_name,
																		photo: shift['provider'].photo
																	});
																	boxProviderSdls[key].push({ id: shift.id, swap_request: shift.swap_request });
																	//push into result array
																	result.push({
																		start: startOfDay(shift.shift_date),
																		end: endOfDay(shift.shift_date),
																		psid: shift.id,
																		sdlname: _scheduleShift.schedule.name,
																		schedules: obSchedules,
																		//title: boxTitle[_scheduleShift.schedule.id] + boxDoctors[shift.shift.id + '_' + shift.shift_timestamp],
																		title: boxTitle[_scheduleShift.schedule.id],
																		schedule: _scheduleShift.schedule.name,
																		totalDocs: totalShiftDocs[_scheduleShift.day],
																		doctors: obDoctors[key],
																		provider_schedules: boxProviderSdls[key],
																		color: bgcolor,
																		totalReqDoctors: totalReqDoctors[_scheduleShift.day],
																		totalAvailDoctors: totalAvailDoctors[shift.shift_date_format],
																		resizable: {
																			beforeStart: true,
																			afterEnd: true
																		},
																		draggable: false
																	});

																	// console.log(result);
																}
															})
															.catch(err => _reject(err));
														}
													});
												});
												t++;
												_promiseArr.push(_promise);
											}
											Promise.all(_promiseArr).then(res => resolve(res)).catch(err => reject(err));
										});
									});
								});
							}
							Promise.all(promiseArr2).then(shifts => {
								let _shifts = [];
								if (shifts && shifts.length > 0) {
									shifts.forEach(function (shift) {
										_shifts = _shifts.concat(shift);
									});
								}
								// this.view = 'month';
							})
							.catch();
						})
						.catch(err => console.log(err))
				}
			});
		});
		console.log(result);
		// this.spinnerService.hide();
		return result;
	}

	addDoctor(){
		this.router.navigate(['/add-doctor']);
	}

	ngOnInit() {
		this.provider = null;
		this.getDoctorsList();
		this.clearFilter();
	}

	fetchEvents(): void {
		let self = this;
		self.spinnerService.show();
		setTimeout(() => {
			//this.view = 'month';
			this.refresh.next();
			self.spinnerService.hide();
		}, 5000);
	}

	dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
		if (isSameMonth(date, this.viewDate)) {
			if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
				this.activeDayIsOpen = false;
			} else {
				this.activeDayIsOpen = true;
				this.viewDate = date;
			}
		}
	}

	eventTimesChanged({
        event,
		newStart,
		newEnd
  	}: CalendarEventTimesChangedEvent): void {
		event.start = newStart;
		event.end = newEnd;
		this.handleEvent('Dropped or resized', event);
		this.refresh.next();
	}

	handleEvent(action: string, event: CalendarEvent): void {
		this.modalData = { event, action };
		this.modal.open(this.modalContent, { size: 'lg' });
	}

}



// WEBPACK FOOTER //
// ./src/app/modules/doctors/doctors.component.ts